var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7231 2.59228H9.84615L8.45785 1.20397C8.08369 0.829816 7.58154 0.623047 7.05969 0.623047H1.96923C0.886154 0.623047 0.00984615 1.5092 0.00984615 2.59228L0 14.4077C0 15.4907 0.886154 16.3769 1.96923 16.3769H17.7231C18.8062 16.3769 19.6923 15.4907 19.6923 14.4077V4.56151C19.6923 3.47843 18.8062 2.59228 17.7231 2.59228ZM10.8308 9.48459V12.4384C10.8308 12.98 10.3877 13.423 9.84615 13.423C9.30462 13.423 8.86154 12.98 8.86154 12.4384V9.48459H7.09908C6.656 9.48459 6.43938 8.95289 6.75446 8.64766L9.51138 5.90059C9.70831 5.70366 10.0135 5.71351 10.2105 5.90059L12.9575 8.64766C13.2529 8.95289 13.0363 9.48459 12.6031 9.48459H10.8308Z",
    fill: "#DADCDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLogo2);
export default __webpack_public_path__ + "static/media/upload-logo-2.b97bfa66d8fe95b1776aa632587728ba.svg";
export { ForwardRef as ReactComponent };